
export class AccountReservation {
    accountNumber: number;
    issuedDate: Date;
    issuedTo: string;
    externalId: string;
    issueReason: string;
    correlationId: string;
    
    constructor(accountNumber? : number, issuedDate? : Date, issuedTo? : string, externalId? : string, issueReason? : string, correlationId? : string) {
      this.accountNumber = accountNumber || -1;
      this.issuedDate = issuedDate || new Date();
      this.issuedTo = issuedTo || "";
      this.externalId = externalId || "";
      this.issueReason = issueReason || "";
      this.correlationId = correlationId || "";
    }
  }
  